import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { StudentService } from 'src/app/services/Student/student.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-student-category-report',
  templateUrl: './student-category-report.component.html',
  styleUrls: ['./student-category-report.component.css']
})
export class StudentCategoryReportComponent implements OnInit {
  CategoryHeaderList :any;
  CategoryList :any;
  GrandTotal :any;
  CategoryClassList :any;
  constructor(private financeService:FinanceService,private studentService:StudentService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }


  GetSummaryReport  () {   
    this.spinnerService.show();
    this.studentService.GetCategorySummaryReport("").subscribe( (data)=> {
        this.CategoryHeaderList = data.CategoryHeaderList;
        this.CategoryList = data.CategoryList;
        this.GrandTotal = data.GrandTotal;
        this.CategoryClassList = data.CategoryClassList;
        this.spinnerService.hide();
    });

};
// Download

XLSReport  () {
    this.JSONToCsvCategoryList(this.CategoryClassList, 'Student_Category_List', true);
}

 JSONToCsvCategoryList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Class' + ',';
        for (var j = 0; j < this.CategoryList.length; j++) {
            row += this.CategoryList[j].ItemName + ',';
            row += '' + ',';
        }
        row += 'Total' + ',';
        row += '' + ',';
        row += 'Total(M+F)' + ',';
     
        CSV += row + '\r\n';
        var row1 = "";
        row1 += '' + ',';
        for (var k = 0; k < this.CategoryHeaderList.length; k++) {
            row1 += this.CategoryHeaderList[k] + ',';
        }
        row1 += 'M' + ',';
        row1 += 'F' + ',';
        
        CSV += row1 + '\r\n';
    }
   
  
    for (var i = 0; i < arrayData.length; i++) {
        
        for (var j = 0; j < arrayData[i].SectionCategoryList.length; j++) {
            var row2 = "";
            row2 += arrayData[i].SectionCategoryList[j].ClassName + ',';                   
            for (var l = 0; l < arrayData[i].SectionCategoryList[j].GenderCount.length; l++) {                        
                row2 += arrayData[i].SectionCategoryList[j].GenderCount[l] + ',';
            }
            CSV += row2 + '\r\n';
        }
       
        var row3 = "";
        row3 += 'Class Total' + ',';
        for (var k = 0; k < arrayData[i].ClassGenderCount.length; k++) {
            row3 += arrayData[i].ClassGenderCount[k] + ',';
        }
     
        CSV += row3 + '\r\n';
    }
    var row4 = "";
    row4 += 'Grand Total' + ',';
    for (var j = 0; j < this.GrandTotal.length; j++) {
        row4 += this.GrandTotal[j] + ',';
    }
    row.slice(0, row.length - 1);
    CSV += row4 + '\r\n';
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');

    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}




  ngOnInit() {
    this.GetSummaryReport();
  }

}
